<template>
  <div>
    <nav-bar></nav-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import NavBar from "@/components/SettingsNavBar";
import router from "../router/settings-router";

export default {
  components: {
    NavBar
  },
  router
};
</script>
<style>
.form-settings {
  padding: 20px;
}

.el-menu-item,
.el-submenu {
  text-transform: uppercase;
}
</style>
